import { AuditTrailRecordDTO } from "../interface/audit-trail.interface";

export const AUDIT_TRAIL_CONSTANT = {
  auditTrail: `Audit Trail`,
}

export const AUDIT_TRAIL_TABLE_COLUMNS = [
  'Index',
  'Field Name',
  'Modified By',
  'DateTime',
  'Old Value',
  'New Value',
];

export const AUDIT_MOCK: AuditTrailRecordDTO[] = [
  {
    Index: 1,
    'Field Name': 'Source System',
    'Modified By': 'Ankit Gupta',
    'DateTime': '2015-11-24 15:46:19.000',
    'Old Value': ['TBBS and SAP', 'TBBS and SAP'],
    'New Value': ['adjustments were recorded in 2010.', 'adjustments were recorded in 2010. Test'],
  },
  {
    Index: 2,
    'Field Name': 'Source System',
    'Modified By': 'Ankit Gupta',
    'DateTime': '2015-11-24 15:46:19.000',
    'Old Value': ['', 'adjustments were recorded in 2010.'],
    'New Value': ['', 'adjustments were recorded in 2010. Test'],
  },
  {
    Index: 3,
    'Field Name': 'Tax Rate',
    'Modified By': 'Michael Brown',
    'DateTime': '2015-11-24 15:46:19.000',
    'Old Value': ['15%', 'Federal tax rate'],
    'New Value': ['18%', 'Federal tax rate updated'],
  },
  {
    'Field Name': 'Entity Name',
    'Modified By': 'David Miller',
    'DateTime': '2015-11-24 15:46:19.000',
    'Old Value': ['ABC Corp', 'Active Entity'],
    'New Value': ['ABC Corporation', 'Active Entity'],
  },
  {
    'Field Name': 'Issue Status',
    'Modified By': 'Emma Davis',
    'DateTime': '2015-11-24 15:46:19.000',
    'Old Value': ['Open', 'Assigned to Team A'],
    'New Value': ['Closed', 'Resolved successfully'],
  },
  {
    'Field Name': 'Category',
    'Modified By': 'Robert White',
    'DateTime': '2015-11-24 15:46:19.000',
    'Old Value': ['General', 'Business Category'],
    'New Value': ['Tax', 'Business Category'],
  },
  {
    'Field Name': 'Country',
    'Modified By': 'Chris Taylor',
    'DateTime': '2015-11-24 15:46:19.000',
    'Old Value': ['United States', 'Primary Jurisdiction'],
    'New Value': ['Canada', 'Primary Jurisdiction'],
  },
  {
    'Field Name': 'Currency',
    'Modified By': 'William Lee',
    'DateTime': '2015-11-24 15:46:19.000',
    'Old Value': ['USD', 'Default Currency'],
    'New Value': ['CAD', 'Default Currency'],
  },
  {
    'Field Name': 'Reviewer',
    'Modified By': 'Sophia Green',
    'DateTime': '2015-11-24 15:46:19.000',
    'Old Value': ['John Doe', 'Senior Reviewer'],
    'New Value': ['Jane Doe', 'Senior Reviewer'],
  },
  {
    'Field Name': 'Description',
    'Modified By': 'Olivia Martin',
    'DateTime': '2015-11-24 15:46:19.000',
    'Old Value': ['Original Description', 'Created in 2023'],
    'New Value': ['Updated Description', 'Reviewed in 2024'],
  },
  {
    'Field Name': 'Reviewer',
    'Modified By': 'Sophia Green',
    'DateTime': '2015-11-24 15:46:19.000',
    'Old Value': ['John Doe', 'Senior Reviewer'],
    'New Value': ['Jane Doe', 'Senior Reviewer'],
  },
  {
    'Field Name': 'Description',
    'Modified By': 'Olivia Martin',
    'DateTime': '2015-11-24 15:46:19.000',
    'Old Value': ['Original Description', 'Created in 2023'],
    'New Value': ['Updated Description', 'Reviewed in 2024'],
  },
  {
    'Field Name': 'Reviewer',
    'Modified By': 'Sophia Green',
    'DateTime': '2015-11-24 15:46:19.000',
    'Old Value': ['John Doe', 'Senior Reviewer'],
    'New Value': ['Jane Doe', 'Senior Reviewer'],
  },
  {
    'Field Name': 'Description',
    'Modified By': 'Olivia Martin',
    'DateTime': '2015-11-24 15:46:19.000',
    'Old Value': ['Original Description', 'Created in 2023'],
    'New Value': ['Updated Description', 'Reviewed in 2024'],
  },
  {
    'Field Name': 'Reviewer',
    'Modified By': 'Sophia Green',
    'DateTime': '2015-11-24 15:46:19.000',
    'Old Value': ['John Doe', 'Senior Reviewer'],
    'New Value': ['Jane Doe', 'Senior Reviewer'],
  },
  {
    'Field Name': 'Description',
    'Modified By': 'Olivia Martin',
    'DateTime': '2015-11-24 15:46:19.000',
    'Old Value': ['Original Description', 'Created in 2023'],
    'New Value': ['Updated Description', 'Reviewed in 2024'],
  },
];
